import commonJsModule from "webpack-merge"

export default commonJsModule.default